<template>
    <el-dialog :title="title" :visible.sync="visible" width="500px">
        <el-form label-width="80px" ref="form" :model="form" :rules="rules">
            <el-form-item label="等级名称" prop="name">
                <el-input placeholder="请输入等级名称" v-model="form.name"></el-input>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="visible = false">取 消</el-button>
            <el-button type="primary" @click="handleConfirm">确 定</el-button>
        </span>
    </el-dialog>
</template>

<script>
import { add, edit } from "@/api/proxy/level";
export default {
    data() {
        return {
            form: {},
            visible: false,
            title: "",
            rules: {
                name: [{ required: true, message: "请输入等级名称" }],
            },
        };
    },
    methods: {
        open(row) {
            if (row) {
                this.title = "编辑等级";
            } else {
                this.title = "新增等级";
            }
            this.form = row || {};
            this.visible = true;
        },
        handleConfirm() {
            this.$refs.form.validate((valid) => {
                if (!valid) return;
                if (!this.form.uuid) {
                    add({ name: this.form.name }).then(({ code, error }) => {
                        if (code === 200) {
                            this.$message.success("新增成功");
                            this.visible = false;
                            this.$emit("update");
                        } else {
                            this.$message.error(error.message);
                        }
                    });
                } else {
                    edit({ uuid: this.form.uuid, name: this.form.name }).then(({ code, error }) => {
                        if (code === 200) {
                            this.$message.success("编辑成功");
                            this.visible = false;
                            this.$emit("update");
                        } else {
                            this.$message.error(error.message);
                        }
                    });
                }
            });
        },
    },
};
</script>

<style></style>
